// Settings configured here will be merged into the final config object.
import { HearkenStatus } from 'types/hearkenStatus'

export default {
  articleId: '30187656',
  googleSheetKey: '1wOKc4_4fQfwBjuwkeEoGgx0tQiFBEkFzFPmYkfSLy0c',
  embeds: {
    [HearkenStatus.VOTING]: [
      'https://modules.wearehearken.com/tages-anzeiger/embed/3718.js'
    ],
    [HearkenStatus.COLLECTING]: [
      'https://modules.wearehearken.com/tages-anzeiger/embed/3717.js'
      // 'https://modules.wearehearken.com/tages-anzeiger/embed/3767.js'
    ],
    [HearkenStatus.PUBLISHING]: [],
    [HearkenStatus.INVESTIGATING]: []
  }
}
